import NotFound from './NotFound';
export type { NotFoundProps } from './NotFound.types';

export default NotFound;
